import { createStore, applyMiddleware, compose } from 'redux';
import {
  persistStore,
  persistCombineReducers,
  createTransform,
} from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { routerMiddleware } from 'react-router-redux';
import _ from 'lodash';
import createHistory from 'history/createBrowserHistory';

import MPWWebApi from 'API/MPWApi';
import { signalRMiddleware } from 'API/SignalR/';
import { LOGIN_FORM_NAME } from 'Common/FormEnum';
import { CLEAR_STATE } from 'State/types';
import { baseUrl } from 'API/Connection';

import reducers from './reducers';
import createTransactionMiddleware from './offline/transactionMiddleware';
import {
  createThunkMiddleware,
  createRequestCancelationMiddleware,
} from 'Common/Middleware';

const isDev = process.env.NODE_ENV.trim() !== 'production';

/** Blacklists keys even if the reducer key is whitelisted  */
const blacklistTransform = createTransform((inbound, key) => {
  switch (key) {
    case 'GlobalUIState':
      return _.omit(inbound, ['fullscreen', 'isSidebarMessagesPanelActive']);
    default:
      return inbound;
  }
});

const reduxPersistConfig = {
  key: 'MPW',
  storage,
  version: 1.01,
  debug: isDev,
  whitelist: ['SecurityState', 'GlobalUIState', 'UserSettingsState'],
  transforms: [blacklistTransform],
};

//a test comment here
const reducer = persistCombineReducers(reduxPersistConfig, reducers);

//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
const rootReducer = (state, action) => {
  if (action.type === CLEAR_STATE) {
    const form = { [LOGIN_FORM_NAME]: { ...state.form[LOGIN_FORM_NAME] } };
    const {
      routing,
      _persist,
      SecurityState,
      GlobalUIState,
      UserSettingsState,
      CommonState: prevCommonState,
      SignalRState,
    } = state;
    //whitelist - dont clear these

    /** Don't reset the current online state */
    const CommonState = _.pick(prevCommonState, [
      'connection.online',
      'connection.serverUp',
      'connection.offlineMode',
    ]);
    state = {
      routing,
      _persist,
      SecurityState,
      GlobalUIState,
      form,
      UserSettingsState,
      CommonState,
      SignalRState,
    };
  }

  return reducer(state, action);
};

export default () => {
  const history = createHistory();
  const middleware = [
    createThunkMiddleware(MPWWebApi),
    createRequestCancelationMiddleware(),
    routerMiddleware(history),
    signalRMiddleware(baseUrl),
    createTransactionMiddleware(),    
  ];

  //leave this for when offline comes into play..this works for redux offline per Anthony
  // let store = createStore(
  //   reducer,
  //   compose(
  //     applyMiddleware(...middleware),
  //     offline({ ...offlineConfig, persistCallback: () => store.dispatch( { type: 'test'})}),
  //     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  //   )
  // );

  /**
   * If the Redux DevTools weren't installed the app would crash.
   * The middleware is expecting a function.
   * @todo make better :)
   */
  const reduxDevToolsExtension =
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'undefined'
      ? () => {
          return next => action => {
            return next(action);
          };
        }
      : window.__REDUX_DEVTOOLS_EXTENSION__;

  let store = isDev
    ? createStore(
        rootReducer,
        compose(applyMiddleware(...middleware), reduxDevToolsExtension())
      )
    : createStore(rootReducer, compose(applyMiddleware(...middleware)));

  let persistor = persistStore(store);
  //persistor.purge();

  return { store, history, persistor };
};



// WEBPACK FOOTER //
// ./src/store.js